
import Vue from 'vue'
import BaseListContainer from '@/containers/base/BaseListContainer.vue'
import EchangeFilter from '@/components/filters/EchangeFilter.vue'
import PageLayout from '@/layouts/Page.vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import SelectConseiller from '@/components/common/SelectConseiller.vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import {isEmptyObject} from '@/helpers'
import {optionsVslim} from '@/config/v-slim-dialog'

const echangeModule = namespace('echange')

@Component({
  components: {
    PageLayout,
    PageMenuLayout,
    BaseListContainer,
    EchangeFilter,
    SelectRef,
    SelectConseiller
  }
})
export default class ProspectList extends Vue {
  @echangeModule.Action('getEchangesAction') getEchanges: any
  @echangeModule.Action('getEchangeByIdAction') getEchangeById: any
  @echangeModule.Action('saveEchangeSortParamsAction') saveEchangeSortParams: any
  @echangeModule.Action('saveEchangeFilterParamsAction') saveEchangeFilterParams: any
  @echangeModule.Action('saveEchangeLimitParamAction') saveEchangeLimitParam: any
  @echangeModule.Getter('echangesGetter') echanges: any
  @echangeModule.Getter('echangeSortParamsGetter') echangeSortParams: any
  @echangeModule.Getter('echangePaginationParamsGetter') echangePaginationParams: any

  rows = [
    {name: 'Id prospect', key: 'ID', orderable: true},
    {name: 'Lot', key: 'NOMBRE_LOTS_PRINCIPAUX', orderable: false},
    {name: 'Nom', key: 'NOM', orderable: false},
    {name: 'Tél', key: 'TEL', orderable: false},
    {name: 'Date échange', key: 'DATE_ECHANGE', orderable: true},
    {name: 'Type', key: 'TYPE', orderable: false},
    {name: 'Prochaine action', key: 'DATE_PROCHAINE_ACTION', orderable: false},
    {name: 'Date ouverture', key: 'DATE_OUVERTURE', orderable: false}
  ]

  panel = null

  @Watch('$route.query', {deep: false})
  watchRouteParams(val: any) {
    if (isEmptyObject(val)) this.getEchanges({})
  }

  mounted() {
    this.getEchanges(this.$route.query)
  }

  beforeDestroy() {
    if (this.panel) this.panel.hide()
  }

  telHandler(tel: any) {
    document.location.href = `tel:${tel}`
  }

  previewHandler(item: any) {
    const id = item.ID_PROSPECT
    const routeData = this.$router.resolve({name: 'prospectEchange', params: {id}})
    window.open(routeData.href, '_blank')
  }

  onDetailHandler(item: any) {
    const id = item.ID_PROSPECT
    const routeData = this.$router.resolve({name: 'prospectEchange', params: {id}})
    window.open(routeData.href, '_blank')
  }

  onSortHandler(params: any) {
    this.saveEchangeSortParams(params)
    const query = {
      ...this.$route.query,
      ...params
    }
    this.getEchanges(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onPaginateHandler(page) {
    const query = {
      ...this.$route.query,
      page
    }
    this.getEchanges(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onPaginatePrevHandler(page) {
    this.onPaginateHandler(page)
  }

  onPaginateNextHandler(page) {
    this.onPaginateHandler(page)
  }

  onChangeLimitHandler(limit) {
    this.saveEchangeLimitParam(limit)
    const query = {
      ...this.$route.query,
      limit
    }
    this.getEchanges(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onFilterHandler(data) {
    this.saveEchangeFilterParams(data)
    const query = {
      action: 'filtre',
      ...this.$route.query,
      ...data,
      page: null
    }
    this.getEchanges(query)
    this.$router.replace({path: this.$route.params[0], query})
  }

  onResetFilterHandler() {
    this.getEchanges(null)
    this.$router.replace({path: this.$route.params[0], query: null})
  }
}
